// Types
import { ContactField_type, Property } from '@trii/types/dist/Contacts';
// Components
import { TextField } from '@mui/material';

type CustomPropertyInputProps = Property & {
  onChange: (name: string, value: any) => void;
  min?: number | null;
  max?: number | null;
};

const CustomPropertyInput = ({
  nameKey,
  value,
  onChange,
  type,
  min,
  max,
}: CustomPropertyInputProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (
      type === ContactField_type.NUMBER_ACCOUNTING ||
      type === ContactField_type.NUMBER_DECIMAL ||
      type === ContactField_type.NUMBER_CURRENCY ||
      type === ContactField_type.CURRENCY
    ) {
      handleNumberTypeChange(event);
    } else if (type === ContactField_type.NUMBER_INTEGER) {
      handleIntegerNumberTypeChange(event);
    } else if (
      type === ContactField_type.LONGTEXT ||
      type === ContactField_type.TEXT ||
      type === ContactField_type.ADDRESS
    ) {
      handleTextTypeChange(event);
    }
  };

  const handleTextTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(nameKey, event.target.value);
  };

  const handleNumberTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const sanitizedInput = inputValue.replace(/[^0-9.-]/g, '');
    if (sanitizedInput === '' || sanitizedInput === '-') {
      onChange(nameKey, sanitizedInput);
      return;
    }
    const num = Number(sanitizedInput);
    if (Number.isNaN(num)) return;
    onChange(nameKey, sanitizedInput);
  };

  const handleIntegerNumberTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue === '') {
      onChange(nameKey, newValue);
      return;
    }
    if (!/^\d*$/.test(newValue)) return;
    onChange(nameKey, newValue);
  };

  const isNumericType = () => {
    return (
      type === ContactField_type.CURRENCY ||
      type === ContactField_type.NUMBER_ACCOUNTING ||
      type === ContactField_type.NUMBER_DECIMAL ||
      type === ContactField_type.NUMBER_INTEGER ||
      type === ContactField_type.NUMBER_CURRENCY
    );
  };

  const isOutOfRange = () => {
    if (!isNumericType() || value === '' || value == null) return false;
    const num = Number(value);
    if (Number.isNaN(num)) return false;
    if (min != null && num < min) return true;
    if (max != null && num > max) return true;
    return false;
  };

  const getRangeHelperText = () => {
    if (!isNumericType()) return undefined;
    if (min != null && max != null) return `${min} - ${max}`;
    if (min != null) return `min: ${min}`;
    if (max != null) return `max: ${max}`;
    return undefined;
  };

  return (
    <TextField
      size="small"
      variant="standard"
      value={value}
      onChange={handleChange}
      error={isOutOfRange()}
      helperText={getRangeHelperText()}
      inputProps={{
        pattern: '[0-9]*',
      }}
      multiline={type === ContactField_type.LONGTEXT}
      rows={type === ContactField_type.LONGTEXT ? 4 : 1}
      sx={{ width: '100%' }}
    />
  );
};

export default CustomPropertyInput;
